import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import CosLayoutMain from '@/components/CosLayoutMain/index.vue'
import BusinessForm from './components/BusinessForm.vue'
import { goBack } from '@/hooks/cosRouter'
import { businessCreateOrEdit } from '@/api/yuntuSales/chanceManage'
import type { LbuBusinessEditParams } from '@/typings/api/chanceManage'


const __default__ = { name: 'DcCosLbuBusinessAdd' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()

const dataForm = ref<LbuBusinessEditParams>({})

// 赋值url参数到dataForm
const saleChanceRefId = ref<boolean>()
if (route.query.saleChanceRefId) {
  dataForm.value.saleChanceRefId = route.query.saleChanceRefId as string
  saleChanceRefId.value = true
}
if (route.query.isFromPotentialCustomer) {
  dataForm.value.isFromPotentialCustomer = true
}
const fetch = (val: any) => {
  dataForm.value = val
}

const businessFormRef = ref()

const loading = ref(false)
const handleSubmit = (type?: string) => {
  businessFormRef.value?.validate().then(() => {
    loading.value = true
    businessCreateOrEdit(dataForm.value)
      .then(() => {
        message.success('新增成功')
        const {
          saleChanceRefId,
          status,
          saleChanceType,
          competitors,
          competitionSituation,
          customerSituation,
          requiredSupport,
          remark
        } = dataForm.value
        businessFormRef.value?.resetFields()
        if (type === 'again') {
          dataForm.value = {
            saleChanceRefId,
            status,
            saleChanceType,
            competitors,
            competitionSituation,
            customerSituation,
            requiredSupport,
            remark
          }
        } else {
          goBack()
        }
      })
      .finally(() => {
        loading.value = false
      })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(CosLayoutMain, null, {
    content: _withCtx(() => [
      _createVNode(BusinessForm, {
        ref_key: "businessFormRef",
        ref: businessFormRef,
        title: "新增商机",
        type: "add",
        value: dataForm.value,
        "onUpdate:value": [
          _cache[0] || (_cache[0] = ($event: any) => ((dataForm).value = $event)),
          fetch
        ],
        saleChanceRefId: saleChanceRefId.value
      }, null, 8, ["value", "saleChanceRefId"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_cos_footer_button, {
        loading: loading.value,
        value: dataForm.value,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((dataForm).value = $event)),
        hideOk: "",
        disabled: false,
        resetValue: _ctx.initForm
      }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            type: "primary",
            loading: loading.value,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (handleSubmit()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存 ")
            ]),
            _: 1
          }, 8, ["loading"])), [
            [_directive_permission, 'lbu_business_add_btn']
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            type: "primary",
            loading: loading.value,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (handleSubmit('again')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存并新建 ")
            ]),
            _: 1
          }, 8, ["loading"])), [
            [_directive_permission, 'lbu_business_add_btn']
          ])
        ]),
        _: 1
      }, 8, ["loading", "value", "resetValue"])
    ]),
    _: 1
  }))
}
}

})